/* eslint-disable max-len */
export default {
    'en': {
        'app': 'SDB Composition Editor',

        'menuDrafts': 'Compositions',
        'menuPublished': 'Published',
        'menuAccreditationInfos': 'Accreditatie Settings',
        'menuAccreditations': 'Accreditations',
        'headerDrafts': 'Compositions view',
        'headerCompositions': 'Published compositions view',
        'headerAccreditationInfos': 'Accreditation settings overview',
        'accreditationInfoName': 'Name',
        'accreditationCount': 'Accreditations',
        'headerPublications': 'Publications',
        'headerPortals': 'Portals',
        'headerLtiItems': 'LTI 1.1 modules',
        'headerScormItems': 'SCORM packages',
        'headerOsItems': 'OS Microlearnings',
        'headerLtiAdvantageItems': 'LTI 1.3 modules',
        'headerYoutubeItems': 'YouTube videos',
        'headerDistributions': 'Distributions',
        'headerReplace': 'Replace',

        'single-item': 'Single microlearning',
        'compound': 'Block with multiple microlearnings',
        'compound-test': 'Assessment block',
        'movie': 'Video',
        'animation': 'Animation',
        'audio': 'Audio',
        'infographic': 'Infographic',
        'exercise': 'Exercise',
        'microcourse': 'Microcourse',
        'text': 'Text',
        'test': 'Test',
        'pretest': 'Assessment',
        'elearning': 'E-learning',
        'accreditationinfo': 'accreditation settings',
        'accreditations': 'accreditations',
        'Composition': 'Composition',
        'Elearning': 'LearningPlan',
        'expiresAt': 'expires at',
        'sortBy': 'Sort by',
        'sortName': 'Name',
        'sortExpiration': 'Expiration',
        'sortLastModified': 'Last modified',
        'showExpired': 'Show expired',
        'addAccreditationInfoHeading': 'Add accreditation settings',
        'searchCatalogItem': 'Search catalog item',

        'draftPublished': 'composition published',
        'draftUnpublished': 'Rolled back composition publication',
        'draftCreated': 'composition created',
        'draftDuplicated': 'composition duplicated',
        'draftDeleted': 'composition deleted',
        'draftSaved': 'composition saved',
        'compositionDistributed': 'composition distributed',
        'compositionRollbacked': 'rollback completed',
        'catalogItemsReplaced': 'catalog item(s) replaced',
        'ltiItemPublished': 'LTI 1.1 module published',
        'ltiItemUnpublished': 'Rolled back LTI 1.1 module publication',
        'ltiItemCreated': 'LTI 1.1 module created',
        'ltiItemDuplicated': 'LTI 1.1 module duplicated',
        'ltiItemDeleted': 'LTI 1.1 module deleted',
        'ltiItemSaved': 'LTI 1.1 module saved',
        'ltiAdvantageItemPublished': 'LTI 1.3 module published',
        'ltiAdvantageItemUnpublished': 'Rolled back LTI 1.3 module publication',
        'ltiAdvantageItemCreated': 'LTI 1.3 module created',
        'ltiAdvantageItemSaved': 'LTI 1.3 module saved',
        'deploymentSaved': 'Connection saved',
        'createHeadingLtiAdvantageItem': 'Create new LTI 1.3 module?',
        'ltiSettings': 'LTI 1.3 settings',
        'deployment': 'Supplier connection',
        'deployments': 'Connections',
        'manageDeployments': 'Manage connections',
        'suppliers': 'Suppliers',
        'supplierConnections': 'Supplier connections',
        'addSupplierConnection': 'Add supplier connection',
        'speedDialSupplier': 'Supplier',
        'speedDialElearningModule': 'E-learning module',
        'noDeploymentsForPortal': 'This portal has no connections yet. Add a connection first.',
        'addDeployment': 'Add connection',
        'editDeployment': 'Edit connection',
        'tool': 'Supplier',
        'toolName': 'Supplier name',
        'presetCopiedHint': 'Prefilled with the default details of the supplier.',
        'deploymentExists': 'This portal already has a connection for this supplier. Edit that connection instead.',
        'deploymentNotConfigured': 'not configured yet',
        'registerAutomatically': 'Register automatically',
        'registerAutomaticallyHint': 'Paste the registration URL from the supplier and start the registration. The supplier page opens in a new window. Once the registration is completed, the connection appears here, fully configured.',
        'registerAutomaticallyIntro': 'Paste the registration URL from the supplier and start the registration. The supplier page opens in a new window. Once the registration is completed, the connection appears here, fully configured.',
        'enterManually': 'Enter manually',
        'enterManuallyHint': 'Choose a known supplier or enter the details yourself. You exchange the details with the supplier by hand.',
        'selectSupplier': 'Select supplier',
        'selectSupplierHint': 'The details of the supplier are prefilled.',
        'noSuppliersAvailable': 'All known suppliers are already connected.',
        'loadingSuppliers': 'Loading known suppliers...',
        'enterYourself': 'Enter yourself',
        'enterYourselfHint': 'For a supplier that is not in the list.',
        'toolRegistrationUrl': 'Registration URL from the supplier',
        'startRegistration': 'Start registration',
        'waitingForSupplier': 'Waiting for the supplier to complete the registration in the opened window...',
        'popupBlocked': 'The browser blocked the window.',
        'openSupplierPage': 'Open the supplier page',
        'registrationRejected': 'The supplier sent a registration that cannot be accepted:',
        'registrationRejectedHint': 'The supplier can correct it and try again within the time limit, or you can start over.',
        'registrationExpired': 'The registration was not completed in time. Start again.',
        'retry': 'Try again',
        'urlsOptionalHint': 'Don\'t have all URLs yet? Save the connection as a temporary connection and complete it later via Edit connection.',
        'jwksUrl': 'Public keyset (JWKS) URL',
        'loginUrl': 'Initiate login URL',
        'redirectUrl': 'Tool URL / redirect URL',
        'deepLinkingUrl': 'Deep linking URL',
        'label': 'Name',
        'platformConfig': 'Details for the supplier',
        'platformConfigIntro': 'Send these details to the supplier to set up the connection.',
        'issuer': 'Platform issuer',
        'clientId': 'Client ID',
        'deploymentId': 'Deployment ID',
        'authorizationEndpoint': 'Authentication (OIDC auth) URL',
        'tokenEndpoint': 'Access token URL',
        'jwksUri': 'Platform keyset (JWKS) URL',
        'openIdConfigurationUrl': 'OpenID configuration URL',
        'copyToClipboard': 'Copy',
        'copyAll': 'Copy all',
        'copied': 'Copied to clipboard',
        'closeDialog': 'close',
        'backToList': 'back',
        'resourceLinkCount': 'items',
        'customParameters': 'Custom parameters',
        'customParametersHelper': 'Extra values the supplier receives with every launch of this item, for example course_identifier = 587122CD. The supplier tells you which parameters it expects.',
        'maxAttempts': 'Maximum attempts',
        'masteryScoreHelper': 'Minimum score (0-100) to pass. Leave empty to only register completion.',
        'maxAttemptsHelper': 'Number of attempts after which the result is final. Only with a mastery score; use it when the supplier has no retakes of its own.',
        'launchUrlHelper': 'Uses the default launch URL of the supplier. Only switch on when this module has a unique launch URL.',
        'uniqueLaunchUrl': 'Unique launch URL',
        'advancedSettings': 'Advanced settings',
        'resourceLinkUnavailable': 'The LTI 1.3 settings of this module are not available for this portal.',
        'catalogItem': 'Catalog item',
        'microlearningItem': 'Microlearning',
        'errInvalidNumber': 'Enter a whole number of at least 1',
        'scormItemPublished': 'SCORM item published',
        'scormItemUnpublished': 'Rolled back SCORM item publication',
        'scormItemCreated': 'SCORM item created',
        'scormItemDeleted': 'SCORM item deleted',
        'scormItemSaved': 'SCORM item saved',
        'youtubeItemPublished': 'YouTube video published',
        'youtubeItemUnpublished': 'Rolled back YouTube video publication',
        'youtubeItemCreated': 'YouTube video created',
        'youtubeItemDeleted': 'YouTube video deleted',
        'youtubeItemSaved': 'YouTube video saved',
        'accreditationsSaved': 'Accreditation settings saved',
        'accreditationIncomplete': 'Incomplete',
        'invalidAccreditationMappings': 'Mappings that are incomplete or invalid: ${this.count}. Complete the marked fields before saving:',

        'copy': 'Copy',
        'newBlock': 'New block',
        'newBlockItem': 'New block item',

        'catalog': 'Catalog',
        'publish': 'publish',
        'unpublish': 'rollback publication',
        'preview': 'preview',
        'duplicate': 'duplicate',
        'delete': 'delete',
        'remove': 'remove',
        'create': 'create',
        'save': 'save',
        'ok': 'ok',
        'cancel': 'cancel',
        'preview': 'preview',
        'select': 'select',
        'distribute': 'distribute',
        'add': 'add',
        'preset': 'use preset',
        'continue': 'continue',
        'replace': 'replace',
        'rollback': 'rollback',
        'sort': 'sort',

        'publishHeading': 'Publish composition?',
        'publishBody': 'The current version of this composition will be published.',
        'unpublishHeading': 'Rollback publication?',
        'unpublishBody': 'This composition will be removed from the Catalog.',

        'publishHeadingLtiItem': 'Publish LTI 1.1 module?',
        'publishBodyLtiItem': 'This LTI 1.1 module will be published to the Catalog.',
        'unpublishHeadingLtiItem': 'Rollback publication LTI 1.1 module?',
        'unpublishBodyLtiItem': 'This LTI 1.1 module will be removed from the Catalog.',

        'publishHeadingLtiAdvantageItem': 'Publish LTI 1.3 module?',
        'publishBodyLtiAdvantageItem': 'This LTI 1.3 module will be published to the Catalog.',
        'unpublishHeadingLtiAdvantageItem': 'Rollback publication LTI 1.3 module?',
        'unpublishBodyLtiAdvantageItem': 'This LTI 1.3 module will be removed from the Catalog.',

        'publishHeadingScormItem': 'Publish SCORM package?',
        'publishBodyScormItem': 'This SCORM package will be published to the Catalog.',
        'unpublishHeadingScormItem': 'Rollback publication SCORM package?',
        'unpublishBodyScormItem': 'This SCORM package will be removed from the Catalog.',

        'publishHeadingYoutubeItem': 'Publish YouTube video?',
        'publishBodyYoutubeItem': 'This YouTube video will be published to the Catalog.',
        'unpublishHeadingYoutubeItem': 'Rollback publication YouTube video?',
        'unpublishBodyYoutubeItem': 'This YouTube video will be removed from the Catalog.',

        'duplicateHeading': 'Duplicate composition?',
        'duplicateHeadingtiItem': 'Duplicate LTI 1.1 module?',
        'deleteHeading': 'Delete composition?',
        'deleteHeadingtiItem': 'Delete LTI 1.1 module?',
        'deleteHeadingScormItem': 'Delete SCORM package?',
        'createHeading': 'Create new composition?',
        'createHeadingtiItem': 'Create new LTI 1.1 module?',
        'createHeadingScormItem': 'Create new SCORM package?',
        'createHeadingYoutubeItem': 'Create new YouTube video?',
        'createHeadingYoutubeItemHelper': 'Use the Share button in YouTube to copy the url of the video.',
        'selectedElearningItem': 'Selected e-learning item',
        'urlHeading': 'Enter a URL for the image',
        'deleteBlockHeading': 'Delete block?',
        'deleteBlockItemHeading': 'Delete block item?',
        'chooseMicrolearning': 'Select a microlearning',
        'chooseElearning': 'Select an e-learning item',
        'distributeHeading': 'Distribute composition?',
        'distributeBody': '"${this.compositionName}" will be distributed to the following portals:',
        'replaceHeading': 'Replace catalog items?',
        'replaceBody': '"${this.compositionName}" will replace the selected catalog item on the following portals:',
        'presetHeading': 'Use preset settings',
        'presetBody': 'Would you like set all settings to this supplier\'s preset? This will overwrite all current settings.',
        'dirtyFormHeading': 'Unsaved changes',
        'dirtyFormBody': 'There are changes made that are not saved. Are you sure you want to continue?',
        'rollbackHeading': 'Rollback replace',
        'rollbackBody': 'Are you sure you want to rollback the replace of this catalogitem. All properties will be restored if possible, users will be assigned to the previous catalog item.',

        'lastModified': 'last modified',
        'lastPublished': 'last published',
        'generalSettings': 'General settings',
        'title': 'Draft name',
        'description': 'Description',
        'displayTitle': 'Title',
        'summary': 'Summary',
        'duration': 'Duration',
        'requiredDuration': 'Required duration',
        'lti': 'LTI 1.1 link',
        'url': 'URL',
        'filename': 'Filename',
        'masteryScore': 'Mastery score',
        'blockType': 'Block type',
        'blockItem': 'Block item',
        'blockItemType': 'Block item type',
        'successDeterminator': 'Required for completion',
        'minutes': 'minutes',
        'search': 'Search',
        'numberResults': 'Number of results',
        'noMicrolearningsFound': 'No microlearnings were found',
        'noElearningsFound': 'No e-learning items were found',
        'noCompositionsFound': 'No compositions were found',
        'noLtiItemsFound': 'No LTI 1.1 modules were found',
        'noScormItemsFound': 'No SCORM packages were found',
        'noOsItemsFound':  'No Online Studio microlearnings were found',
        'noLtiAdvantageItemsFound':  'No LTI 1.3 modules were found',
        'noYoutubeItemsFound':  'No YouTube videos were found',
        'noAccreditationsFound': 'No accreditations were found',
        'noAccreditationInfoFound': 'No accreditation settings were found',
        'noReplacements': 'No catalog items have been replaced',
        'invalidScormPackage': 'Not a valid SCORM 1.2 package.',
        'search': 'search',
        'distributePortalsLabel': 'Portals',
        'distributePortalsPlaceholder': 'Select 1 or more portals',
        'noPortals': 'Not distributed yet.',
        'name': 'Name',
        'launchUrl': 'Launch URL',
        'consumerKey': 'Consumer Key',
        'sharedSecret': 'Shared Secret',
        'settings': 'Settings',
        'finishImmediately': 'Will complete immediately',
        'finishAfterNumberOfGrades': 'Completes after number of grades',
        'finishScore': 'Score',
        'masteryScore': 'Masteryscore',
        'canScore': 'Sends grade',
        'bigNumberParameter': 'BIG number parameter',
        'finishScore': 'Finish Score',
        'masteryScore': 'Mastery Score',
        'canScore': 'Report grade',
        'fullScreen': 'Full screen',
        'requireNewWindow': 'Require new window',
        'anonymous': 'Anonymous',
        'parameters': 'Parameters',
        'newKey': 'New parameter',
        'addParameter': 'Add parameter',
        'parameterName': 'Key',
        'parameterValue': 'Value',
        'errDuplicateParameter': 'This name is already in use',
        'keys': 'Keys',
        'completionType': 'Completion type',
        'scoreType': 'Report',
        'keySecretsList': 'Existing key secrets',
        'supplier': 'Supplier',
        'playerType': 'Type',
        'all': 'All',
        'replaceElearning': 'Catalog item to be replaced',
        'replacedElearning': 'Replaced catalog item',
        'visibleUntil': 'Visible until',
        'latestVersion': 'Latest version',
        'previewVersion': 'Preview version',
        'vEnVnNumberParameter': 'V&VN number parameter',
        'version': 'Version',
        'versions': 'Versions',
        'package': 'Package',
        'uploaded': 'Uploaded',
        'uploadNewVersion': 'Upload new version',
        'uploadNewPackage': 'Upload new package',
        'publishedBy': 'By',
        'published': 'Published',
        'scormPackageNotEnabled': 'SCORM package is not ready to display',
        'loading': 'loading data...',
        'selectElearningItem': 'Select an e-learning item',
        'launchType': 'Launch type',
        'newWindowMessage': 'This course will be launched in a new window. Please click the button to open the window.',
        'newWindowOpenedMessage': 'The course has been automatically opened in a new window.',
        'startInNewWIndow': 'Click here to start the course',
        'completionSettings': 'Completion settings',
        'completionType': 'Blocks completion',
        'progressType': 'Items completion',
        'minItems': 'Number of blocks',
        'surpressFinalScore': 'Do not process final score',
        'replaceInProgress': 'Replace in progress...',
        'showAll': 'show all',
        'hide': 'hide',
        'accessDenied': 'Access denied',
        'connectionError': 'Connection error',
        'status': 'Status',

        'REQUIRED_BLOCKS': 'Select which blocks need to be completed',
        'ANY_BLOCK': 'At least one block needs to be completed',
        'ALL_BLOCKS': 'All blocks need to be completed',
        'MIN_NUM_BLOCKS': 'At least this number of blocks need to be completed',
        'ANY_ITEM': 'At least one item needs to be completed',
        'ALL_ITEMS': 'All items must be completed',

        'helper_min2chars': 'Please enter at least 2 characters to begin your search',
        'helper_portalSearch': 'Please select 1 or more portals',
        'helper_activeWhenPortalsSelected': 'Please select at least 1 portal.',
        'helper_copyOptions': 'Assignments and Skills will be replaced automatically',
        'warning_replaceToPortals': 'This catalog item will be replaced on the following portals:',
        'warning_noReplace': 'No portals found where replacement can be made.',
        'replaceAgain': 'Also replace again on this portals',
        'allPortals': 'all portals',

        'expired': 'expired',
        'aboutToExpire': 'about to expire',
        'status': 'Status',
        'processed': 'Processed',
        'result': 'result',
        'user': 'User',
        'course': 'Course',
        'searchCourse': 'Search course',
        'searchUser': 'Search user',
        'processedFrom': 'Processed from',
        'processedTo': 'Processed until',

        'accr.status.accepted': 'Accepted',
        'accr.status.failed': 'Failed',
        'accr.status.error': 'Error',
        'accr.status.invalid': 'Invalid',
        'accr.status.badResponse': 'Bad response',
        'accr.status.pending': 'Pending',
        'accr.status.notValid': 'Not valid',
        'exportExcel': 'Export to Excel',
        'exportFailed': 'Exporting failed.',
        'accrRetry.button': 'Try again',
        'accrRetry.confirm': 'Send again',
        'accrRetry.dialogTitle': 'Send accreditation again',
        'accrRetry.dialogBody': 'Do you want to send this accreditation to PE-online again? The attempt is rebuilt from the current registration numbers of the user and the accreditation settings of the course.',
        'accrRetry.dialogDisclaimer': 'Please note: SDB cannot guarantee that the accreditation will be accepted. Whether an accreditation is accepted is determined by PE-online.',
        'accrRetry.sending': 'Sending…',
        'accrRetry.sent': 'Sent to PE-online again. New status: ${this.status}',
        'accrRetry.notSent': 'Not sent: ${this.reason}',
        'accrRetry.alreadyAccepted': 'PE-online has already accepted this accreditation.',
        'accrRetry.noUserRegistration': 'No registration numbers are known for this user.',
        'accrRetry.noApplicableMapping': 'There is no valid accreditation setting for this professional body on the completion date, or the user has no registration number of the required type.',
        'accrRetry.failed': 'Sending the accreditation again failed.',
        'allStatuses': 'All statuses',
        'allOrganizations': 'All professional bodies',
        'filters': 'Filters',
        'resetFilters': 'Reset filters',
        'sortAccreditations.ProcessedNewest': 'Processed, newest first',
        'sortAccreditations.ProcessedOldest': 'Processed, oldest first',
        'sortAccreditations.User': 'User',
        'sortAccreditations.Status': 'Status',
        'accr.endDate': 'Completed',

        'preset_default': 'Completes when a grade of 100 is send',
        'preset_immediately': 'Completes immediately',
        'preset_firstResult': 'Completes on the first grade',
        'preset_score': 'Completes when the grade is higher or equal to',
        'preset_noScore': 'No grade',
        'preset_showScore': 'Grade',
        'preset_masteryScore': 'Grade and passed/failed based on the mastery score of',

        'pe.externalPersonId': 'PE-online Person ID',
        'pe.courseId': 'PE-online Course ID',
        'pe.courseName': 'PE-online Course name',
        'pe.editionId': 'PE-online Edition ID',
        'pe.moduleId': 'PE-online Module ID',
        'pe.organization': 'Professional body',
        'pe.duration': 'Duration',
        'pe.duration.start': 'Duration start date',
        'pe.duration.end': 'Duration end date',
        'pe.institution': 'Institution',
        'pe.points': 'Points',

        'copyOptions': 'Copy the following catalog properties',
        'flags.title': 'Title',
        'flags.description': 'Description',
        'flags.summary': 'Summary',
        'flags.image': 'Image',
        'flags.categories': 'Categories',
        'flags.documents': 'Documents',
        'flags.evaluation': 'Evaluation form',
        'flags.certificate': 'Certficate',

        'errChooseBetween0_10': 'Choose a number between 0 and 10',
        'errChooseBetween0_100': 'Choose a score between 0 and 100',
        'errRequired': 'This field is required',
        'errorOccurred': 'An error occurred',

        'launchtype_regular': 'In the current window (default)',
        'launchtype_newwindow': 'In a new window/tab',
        'launchtype_newchromelesswindow': 'In a new window without browser controls',

        'createScormItemHelper': 'Name will be filled in automatically with a valid upload',

        'youtube_url': 'YouTube link',
        'youtube_videoId': 'YouTube video ID',
        'youtube_autoplay': 'Autoplay enabled',
        'youtube_mute': 'Mute the video',
        'youtube_startAt': 'Start at (hh:mm:ss)',
        'youtube_endAt': 'End at (hh:mm:ss)',
        'youtubeUrlParseHelper': 'Paste a Youtube Share link here, then click the button to extract video information.',

        'headerVimeoItems': 'Vimeo videos',
        'vimeoItemPublished': 'Vimeo video published',
        'vimeoItemUnpublished': 'Rolled back Vimeo video publication',
        'vimeoItemCreated': 'Vimeo video created',
        'vimeoItemDeleted': 'Vimeo video deleted',
        'vimeoItemSaved': 'Vimeo video saved',

        'publishHeadingVimeoItem': 'Publish Vimeo video?',
        'publishBodyVimeoItem': 'This Vimeo video will be published to the Catalog.',
        'unpublishHeadingVimeoItem': 'Rollback publication Vimeo video?',
        'unpublishBodyVimeoItem': 'This Vimeo video will be removed from the Catalog.',

        'createHeadingVimeoItem': 'Create new Vimeo video?',
        'createHeadingVimeoItemHelper': 'Use the Share button in Vimeo to copy the link of the video.',

        'noVimeoItemsFound': 'No Vimeo videos were found',
        'no_captions': 'No captions',

        'vimeo_url': 'Vimeo link',
        'vimeo_videoId': 'Vimeo video ID',
        'vimeo_autoplay': 'Autoplay enabled',
        'vimeo_mute': 'Mute the video',
        'vimeo_startAt': 'Start at (hh:mm:ss)',
        'vimeo_endAt': 'End at (hh:mm:ss)',
        'vimeo_captions': 'Captions',
        'vimeo_hash': 'Private access code',
        'vimeoUrlParseHelper': 'Paste a Vimeo Share link here, then click the button to extract video information.',
        'vimeoHashHelper': 'This video is private. The automatically detected access code cannot be changed.',
        'vimeoEndAtHelper': 'Vimeo’s end time is not fully supported. It may work in some browsers, but reliability is not guaranteed.',

        'language_nl': 'Dutch',
        'language_en': 'English',

        'parseUrl': 'Load video info',
    },
    'nl': {
        'app': 'SDB Arrangementen Editor',

        'menuDrafts': 'Arrangementen',
        'menuPublished': 'Gepubliceerd',
        'menuAccreditationInfos': 'Accreditatie Instellingen',
        'menuAccreditations': 'Accreditaties',
        'headerDrafts': 'Overzicht arrangementen',
        'headerCompositions': 'Overzicht gepubliceerde arrangementen',
        'headerAccreditationInfos': 'Overzicht accreditatie instellingen',
        'accreditationInfoName': 'Naam',
        'accreditationCount': 'Accreditaties',
        'headerPublications': 'Publicaties',
        'headerPortals': 'Portalen',
        'headerLtiItems': 'LTI 1.1 modules',
        'headerScormItems': 'SCORM pakketten',
        'headerOsItems': 'OS Microlearnings',
        'headerLtiAdvantageItems': 'LTI 1.3 Modules',
        'headerYoutubeItems': 'YouTube video\'s',
        'headerDistributions': 'Uitleveringen',
        'headerReplace': 'Vervangen',

        'single-item': 'Los e-learning onderdeel',
        'compound': 'Blok met 1 of meerdere e-learning onderdelen',
        'compound-test': 'Blok met 1 of meerdere toetsen',
        'movie': 'Video',
        'audio': 'Audio',
        'animation': 'Animatie',
        'infographic': 'Infographic',
        'exercise': 'Oefenen',
        'microcourse': 'Microcursus',
        'text': 'Tekst',
        'test': 'Toets',
        'pretest': 'Test jezelf',
        'elearning': 'E-learning',
        'accreditationinfo': 'accreditatie instellingen',
        'accreditations': 'accreditaties',
        'Composition': 'Arrangement',
        'Elearning': 'Leerplan',
        'expiresAt': 'verloopt op',
        'sortBy': 'Sorteren op',
        'sortName': 'Naam',
        'sortExpiration': 'Verloopdatum',
        'sortLastModified': 'Laatst gewijzigd',
        'showExpired': 'Verlopen tonen',
        'addAccreditationInfoHeading': 'Accreditatie-instellingen toevoegen',
        'searchCatalogItem': 'Zoek catalogusitem',

        'draftPublished': 'arrangement gepubliceerd',
        'draftUnpublished': 'Publicatie arrangement teruggedraaid',
        'draftCreated': 'arrangement aangemaakt',
        'draftDuplicated': 'arrangement gedupliceerd',
        'draftDeleted': 'arrangement verwijderd',
        'draftSaved': 'arrangement opgeslagen',
        'compositionDistributed': 'arrangement uitgeleverd',
        'compositionRollbacked': 'vervangen hersteld',
        'catalogItemsReplaced': 'catalogus item(s) vervangen',
        'ltiItemPublished': 'LTI 1.1 module gepubliceerd',
        'ltiItemUnpublished': 'Publicatie LTI 1.1 module teruggedraaid',
        'ltiItemCreated': 'LTI 1.1 module aangemaakt',
        'ltiItemDuplicated': 'LTI 1.1 module gedupliceerd',
        'ltiItemDeleted': 'LTI 1.1 module verwijderd',
        'ltiItemSaved': 'LTI 1.1 module opgeslagen',
        'ltiAdvantageItemPublished': 'LTI 1.3 module gepubliceerd',
        'ltiAdvantageItemUnpublished': 'Publicatie LTI 1.3 module teruggedraaid',
        'ltiAdvantageItemCreated': 'LTI 1.3 module aangemaakt',
        'ltiAdvantageItemSaved': 'LTI 1.3 module opgeslagen',
        'deploymentSaved': 'Aansluiting opgeslagen',
        'createHeadingLtiAdvantageItem': 'Nieuwe LTI 1.3 module aanmaken?',
        'ltiSettings': 'LTI 1.3 instellingen',
        'deployment': 'Leverancier aansluiting',
        'deployments': 'Aansluitingen',
        'manageDeployments': 'Aansluitingen beheren',
        'suppliers': 'Leveranciers',
        'supplierConnections': 'Leverancier aansluitingen',
        'addSupplierConnection': 'Leverancier aansluiting toevoegen',
        'speedDialSupplier': 'Leverancier',
        'speedDialElearningModule': 'E-learning module',
        'noDeploymentsForPortal': 'Dit portaal heeft nog geen aansluitingen. Voeg eerst een aansluiting toe.',
        'addDeployment': 'Aansluiting toevoegen',
        'editDeployment': 'Aansluiting bewerken',
        'tool': 'Leverancier',
        'toolName': 'Naam van de leverancier',
        'presetCopiedHint': 'Vooraf ingevuld met de standaardgegevens van de leverancier.',
        'deploymentExists': 'Dit portaal heeft al een aansluiting voor deze leverancier. Bewerk die aansluiting in plaats daarvan.',
        'deploymentNotConfigured': 'nog niet ingericht',
        'registerAutomatically': 'Automatisch registreren',
        'registerAutomaticallyHint': 'Plak de registratie-URL van de leverancier en start de registratie. De pagina van de leverancier opent in een nieuw venster. Zodra de registratie is afgerond, verschijnt de aansluiting hier, volledig ingericht.',
        'registerAutomaticallyIntro': 'Plak de registratie-URL van de leverancier en start de registratie. De pagina van de leverancier opent in een nieuw venster. Zodra de registratie is afgerond, verschijnt de aansluiting hier, volledig ingericht.',
        'enterManually': 'Handmatig invoeren',
        'enterManuallyHint': 'Kies een bekende leverancier of voer de gegevens zelf in. Je wisselt de gegevens handmatig uit met de leverancier.',
        'selectSupplier': 'Leverancier selecteren',
        'selectSupplierHint': 'De gegevens van de leverancier worden vooraf ingevuld.',
        'noSuppliersAvailable': 'Alle bekende leveranciers zijn al aangesloten.',
        'loadingSuppliers': 'Bekende leveranciers worden geladen...',
        'enterYourself': 'Zelf invoeren',
        'enterYourselfHint': 'Voor een leverancier die niet in de lijst staat.',
        'toolRegistrationUrl': 'Registratie-URL van de leverancier',
        'startRegistration': 'Registratie starten',
        'waitingForSupplier': 'Wachten tot de leverancier de registratie in het geopende venster afrondt...',
        'popupBlocked': 'De browser heeft het venster geblokkeerd.',
        'openSupplierPage': 'Open de pagina van de leverancier',
        'registrationRejected': 'De leverancier stuurde een registratie die niet geaccepteerd kan worden:',
        'registrationRejectedHint': 'De leverancier kan het corrigeren en binnen de tijd opnieuw proberen, of je start opnieuw.',
        'registrationExpired': 'De registratie is niet op tijd afgerond. Start opnieuw.',
        'retry': 'Opnieuw proberen',
        'urlsOptionalHint': "Heb je nog niet alle URL's? Sla de aansluiting dan op als tijdelijke aansluiting en maak deze later compleet via Aansluiting bewerken.",
        'jwksUrl': 'URL openbare sleutelset (JWKS)',
        'loginUrl': 'Initieer login URL',
        'redirectUrl': 'Tool URL / redirect URL',
        'deepLinkingUrl': 'Deep linking URL',
        'label': 'Naam',
        'platformConfig': 'Gegevens voor de leverancier',
        'platformConfigIntro': 'Geef deze gegevens door aan de leverancier om de aansluiting in te richten.',
        'issuer': 'Platform issuer',
        'clientId': 'Client ID',
        'deploymentId': 'Deployment ID',
        'authorizationEndpoint': 'Authenticatie (OIDC auth) URL',
        'tokenEndpoint': 'Access token URL',
        'jwksUri': 'URL sleutelset (JWKS) van het platform',
        'openIdConfigurationUrl': 'OpenID-configuratie URL',
        'copyToClipboard': 'Kopiëren',
        'copyAll': 'Alles kopiëren',
        'copied': 'Gekopieerd naar het klembord',
        'closeDialog': 'sluiten',
        'backToList': 'terug',
        'resourceLinkCount': 'koppelingen',
        'customParameters': 'Extra parameters',
        'customParametersHelper': 'Extra gegevens die de leverancier bij elke start van deze koppeling meekrijgt, bijvoorbeeld course_identifier = 587122CD. De leverancier geeft aan welke parameters hij verwacht.',
        'maxAttempts': 'Maximaal aantal pogingen',
        'masteryScoreHelper': 'Minimale score (0-100) om te slagen. Laat leeg om alleen afgerond te registreren.',
        'maxAttemptsHelper': 'Aantal pogingen waarna het resultaat definitief is. Alleen met cesuur; gebruik dit als de leverancier zelf geen herkansing kent.',
        'launchUrlHelper': 'Gebruikt de standaard Launch URL van de leverancier. Schakel alleen in als deze module een unieke Launch URL heeft.',
        'uniqueLaunchUrl': 'Unieke Launch URL',
        'advancedSettings': 'Geavanceerde instellingen',
        'resourceLinkUnavailable': 'De LTI 1.3 instellingen van deze module zijn niet beschikbaar voor dit portaal.',
        'catalogItem': 'Catalogusitem',
        'microlearningItem': 'Microlearning',
        'errInvalidNumber': 'Vul een geheel getal van minimaal 1 in',
        'scormItemPublished': 'SCORM pakket gepubliceerd',
        'scormItemUnpublished': 'Publicatie SCORM pakket teruggedraaid',
        'scormItemCreated': 'SCORM pakket aangemaakt',
        'scormItemDeleted': 'SCORM pakket verwijderd',
        'scormItemSaved': 'SCORM pakket opgeslagen',
        'youtubeItemPublished': 'SCORM pakket gepubliceerd',
        'youtubeItemUnpublished': 'Publicatie YouTube video teruggedraaid',
        'youtubeItemCreated': 'YouTube video aangemaakt',
        'youtubeItemDeleted': 'YouTube video verwijderd',
        'youtubeItemSaved': 'YouTube video opgeslagen',
        'accreditationsSaved': 'Accreditatie instellingen opgeslagen',
        'accreditationIncomplete': 'Onvolledig',
        'invalidAccreditationMappings': 'Onvolledige of ongeldige koppelingen: ${this.count}. Vul de gemarkeerde velden aan voordat je opslaat:',

        'copy': 'Kopie',
        'newBlock': 'Nieuw blok',
        'newBlockItem': 'Nieuw e-learning onderdeel',

        'catalog': 'Catalogus',
        'publish': 'publiceren',
        'unpublish': 'terugdraaien publicatie',
        'preview': 'afspelen',
        'duplicate': 'dupliceren',
        'delete': 'verwijderen',
        'remove': 'verwijderen',
        'create': 'aanmaken',
        'save': 'opslaan',
        'ok': 'ok',
        'cancel': 'annuleren',
        'preview': 'afspelen',
        'select': 'selecteren',
        'distribute': 'uitleveren',
        'add': 'toevoegen',
        'preset': 'instellen',
        'continue': 'doorgaan',
        'replace': 'vervangen',
        'rollback': 'herstellen',
        'sort': 'sorteren',

        'publishHeading': 'Arrangement publiceren?',
        'publishBody': 'De huidige versie van het arrangement wordt gepubliceerd.',
        'unpublishHeading': 'Arrangement publicatie terugdraaien?',
        'unpublishBody': 'Dit arrangement wordt verwijderd uit de Catalogus.',

        'publishHeadingLtiItem': 'LTI 1.1 module publiceren?',
        'publishBodyLtiItem': 'Deze LTI 1.1 module wordt gepubliceerd naar de Catalogus.',
        'unpublishHeadingLtiItem': 'Terugdraaien publicatie LTI 1.1 module?',
        'unpublishBodyLtiItem': 'Deze LTI 1.1 module wordt verwijderd uit de Catalogus.',

        'publishHeadingLtiAdvantageItem': 'LTI 1.3 module publiceren?',
        'publishBodyLtiAdvantageItem': 'Deze LTI 1.3 module wordt gepubliceerd naar de Catalogus.',
        'unpublishHeadingLtiAdvantageItem': 'Terugdraaien publicatie LTI 1.3 module?',
        'unpublishBodyLtiAdvantageItem': 'Deze LTI 1.3 module wordt verwijderd uit de Catalogus.',

        'publishHeadingScormItem': 'SCORM pakket publiceren?',
        'publishBodyScormItem': 'Dit SCORM pakket wordt gepubliceerd naar de Catalogus.',
        'unpublishHeadingScormItem': 'Terugdraaien publicatie SCORM pakket?',
        'unpublishBodyScormItem': 'Dit SCORM pakket wordt verwijderd uit de Catalogus.',

        'publishHeadingYoutubeItem': 'YouTube video publiceren?',
        'publishBodyYoutubeItem': 'Deze YouTube video wordt gepubliceerd naar de Catalogus.',
        'unpublishHeadingYoutubeItem': 'Terugdraaien publicatie YouTube video?',
        'unpublishBodyYoutubeItem': 'Deze YouTube video wordt verwijderd uit de Catalogus.',

        'duplicateHeading': 'Arrangement dupliceren?',
        'duplicateHeadingtiItem': 'LTI 1.1 module dupliceren?',
        'deleteHeading': 'Arrangement verwijderen?',
        'deleteHeadingtiItem': 'LTI 1.1 module verwijderen?',
        'deleteHeadingScormItem': 'SCORM pakket verwijderen?',
        'deleteHeadingYoutubeItem': 'YouTube video verwijderen?',
        'createHeading': 'Nieuw arrangement aanmaken?',
        'createHeadingtiItem': 'Nieuwe LTI 1.1 module aanmaken?',
        'createHeadingScormItem': 'Nieuw SCORM pakket aanmaken?',
        'createHeadingYoutubeItem': 'Nieuwe YouTube video aanmaken?',
        'createHeadingYoutubeItemHelper': 'Gebruik de Delen knop in YouTube om de url van de video te kopieren.',
        'selectedElearningItem':'Geselecteerd e-learning onderdeel',
        'urlHeading': 'Selecteer een afbeelding',
        'deleteBlockHeading': 'Blok verwijderen?',
        'deleteBlockItemHeading': 'E-learning onderdeel verwijderen?',
        'chooseMicrolearning': 'Kies een microlearning',
        'chooseElearning': 'Kies een e-learning onderdeel',
        'distributeHeading': 'Arrangement uitleveren?',
        'distributeBody': '"${this.compositionName}" zal worden uitgeleverd op de volgende portalen:',
        'replaceHeading': 'Catalogus items vervangen?',
        'replaceBody': '"${this.compositionName}" zal het geselecteerde catalogus item vervangen op de geselecteerde portalen:',
        'presetHeading': 'Standaard instellingen',
        'presetBody': 'Wil je de standaard instellingen voor deze klant gebruiken? De huidige instellingen zullen worden overschreven.',
        'dirtyFormHeading': 'Wijzigingen niet opgeslagen',
        'dirtyFormBody': 'Er zijn wijzigingen aangebracht die niet zijn opgeslagen. Weet je zeker dat je door wil gaan?',
        'rollbackHeading': 'Herstellen vervangen',
        'rollbackBody': 'Weet je zeker dat je het vervangen wilt herstellen? Alle eigenschappen worden indien mogelijk teruggezet. Ook alle gebruikers zullen weer worden gekoppeld aan het vorige catalogus item.',

        'lastModified': 'laatst gewijzigd',
        'lastPublished': 'laatst gepubliceerd',
        'generalSettings': 'Algemene instellingen',

        'title': 'Werktitel',
        'description': 'Omschrijving',
        'displayTitle': 'Titel',
        'summary': 'Samenvatting',
        'duration': 'Doorlooptijd',
        'requiredDuration': 'Verplichte doorlooptijd',
        'lti': 'LTI 1.1 koppeling',
        'url': 'URL',
        'filename': 'Bestandsnaam',
        'masteryScore': 'Cesuur',
        'blockType': 'Blok type',
        'blockItem': 'E-learning onderdeel',
        'blockItemType': 'Type e-learning onderdeel',
        'successDeterminator': 'Verplicht voor afronding',
        'minutes': 'minuten',
        'search': 'Zoeken naar',
        'numberResults': 'Aantal resultaten',
        'noMicrolearningsFound': 'Er zijn geen microlearnings gevonden',
        'noElearningsFound': 'Er zijn geen e-learning onderdelen gevonden',
        'noCompositionsFound': 'Er zijn geen arrangementen gevonden',
        'noLtiItemsFound': 'Er zijn geen LTI 1.1 modules gevonden',
        'noScormItemsFound': 'Er zijn geen SCORM pakketten gevonden',
        'noOsItemsFound':  'Er zijn geen Online Studio microlearnings gevonden',
        'noLtiAdvantageItemsFound':  'Er zijn geen LTI 1.3 modules gevonden',
        'noYoutubeItemsFound':  'Er zijn geen YouTube video\'s gevonden',
        'noAccreditationsFound': 'Er zijn geen accreditaties',
        'noAccreditationInfoFound': 'Er zijn geen accreditatie instellingen gevonden',
        'noReplacements': 'Er is geen catalogus item vervangen',
        'invalidScormPackage': 'Geen geldig SCORM 1.2 pakket.',
        'search': 'zoeken',
        'distributePortalsLabel': 'Portalen',
        'distributePortalsPlaceholder': 'Selecteer 1 of meerdere portalen',
        'noPortals': 'Nog niet uitgeleverd.',
        'name': 'Naam',
        'launchUrl': 'Launch URL',
        'consumerKey': 'Consumer Key',
        'sharedSecret': 'Shared Secret',
        'settings': 'Instellingen',
        'finishImmediately': 'Rondt gelijk af bij opstarten',
        'finishAfterNumberOfGrades': 'Rondt af na aantal scores',
        'finishScore': 'Score',
        'masteryScore': 'Cesuur',
        'canScore': 'Meldt score',
        'bigNumberParameter': 'BIG-nummer parameter',
        'fullScreen': 'Volledig scherm',
        'requireNewWindow': 'Opent in een nieuw scherm',
        'anonymous': 'Anonieme gebruikergegevens',
        'finishScore': 'Afronden bij score',
        'masteryScore': 'Cesuur',
        'canScore': 'Toon score',
        'fullScreen': 'Volledig scherm',
        'requireNewWindow': 'Nieuw scherm',
        'anonymous': 'Anonieme gebruikergegevens',
        'parameters': 'Parameters',
        'newKey': 'Nieuwe parameter',
        'addParameter': 'Parameter toevoegen',
        'parameterName': 'Parameter',
        'parameterValue': 'Waarde',
        'errDuplicateParameter': 'Deze naam is al in gebruik',
        'keys': 'Sleutelwaardes',
        'completionType': 'Afronding',
        'scoreType': 'Rapportage',
        'keySecretsList': 'Eerder ingevoerde sleutelwaardes',
        'supplier': 'Leverancier',
        'playerType': 'Type',
        'all': 'Alle',
        'replaceElearning': 'Te vervangen catalogus item',
        'replacedElearning': 'Vervangen catalogus item',
        'visibleUntil': 'Zichtbaar tot',
        'latestVersion': 'Huidige versie',
        'previewVersion': 'Preview versie',
        'vEnVnNumberParameter': 'V&VN-nummer parameter',
        'version': 'Versie',
        'versions': 'Versies',
        'package': 'Pakket',
        'uploaded': 'Geüpload',
        'uploadNewVersion': 'Upload nieuwe versie',
        'uploadNewPackage': 'Upload nieuw pakket',
        'publishedBy': 'Door',
        'published': 'Gepubliceerd',
        'scormPackageNotEnabled': 'SCORM pakket is nog niet gereed',
        'loading': 'bezig om gegevens op te halen...',
        'selectElearningItem': 'Kies een e-learning onderdeel',
        'launchType': 'Opstart type',
        'newWindowMessage': 'Deze e-learning zal worden gestart in een nieuw scherm. Klik op onderstaande knop om de e-learning te starten.',
        'newWindowOpenedMessage': 'De e-learning is automatisch geopend in een nieuw scherm.',
        'startInNewWIndow': 'Klik hier om de e-learning te openen',
        'completionSettings': 'Afrondingsinstellingen',
        'completionType': 'Afronding blokken',
        'progressType': 'Afronding onderdelen',
        'minItems': 'Aantal blokken',
        'surpressFinalScore': 'Geen eindscore verwerken',
        'replaceInProgress': 'Bezig met vervangen...',
        'showAll': 'toon alles',
        'hide': 'verberg',
        'accessDenied': 'Geen toegang',
        'connectionError': 'Connectie error',
        'status': 'Status',

        'REQUIRED_BLOCKS': 'Selecteer welke blokken verplicht zijn',
        'ANY_BLOCK': 'Tenminste 1 blok dient afgerond te zijn',
        'ALL_BLOCKS': 'Alle blokken moeten afgerond zijn',
        'MIN_NUM_BLOCKS': 'Tenminste dit aantal blokken dient afgerond te zijn',
        'ANY_ITEM': 'Tenminste één item moet worden afgerond',
        'ALL_ITEMS': 'Alle items moeten worden afgerond',

        'helper_min2chars': 'Voer minimaal 2 tekens in om te zoeken.',
        'helper_activeWhenPortalsSelected': 'Selecteer tenminste 1 portaal.',
        'helper_portalSearch': 'Selecteer 1 of meerdere portalen',
        'helper_copyOptions': 'Toewijzingen en bekwaamheden worden automatisch overgezet.',
        'warning_replaceToPortals': 'Dit catalogus item wordt nu vervangen op de volgende portalen:',
        'warning_noReplace': 'Geen portalen gevonden waarop vervangen kan worden.',
        'replaceAgain': 'Ook opnieuw vervangen op deze portalen',
        'allPortals': 'Alle portalen',

        'expired': 'verlopen',
        'aboutToExpire': 'verloopt binnenkort',
        'status': 'Status',
        'processed': 'Verwerkt',
        'result': 'Resultaat',
        'user': 'Gebruiker',
        'course': 'Cursus',
        'searchCourse': 'Zoek cursus',
        'searchUser': 'Zoek gebruiker',
        'processedFrom': 'Verwerkt vanaf',
        'processedTo': 'Verwerkt tot en met',

        'accr.status.accepted': 'Geaccepteerd',
        'accr.status.failed': 'Mislukt',
        'accr.status.error': 'Fout',
        'accr.status.invalid': 'Ongeldig',
        'accr.status.badResponse': 'Server fout',
        'accr.status.pending': 'In afwachting',
        'accr.status.notValid': 'Niet geldig',
        'exportExcel': 'Exporteren naar Excel',
        'exportFailed': 'Exporteren is niet gelukt.',
        'accrRetry.button': 'Probeer opnieuw',
        'accrRetry.confirm': 'Opnieuw versturen',
        'accrRetry.dialogTitle': 'Accreditatie opnieuw versturen',
        'accrRetry.dialogBody': 'Wil je deze accreditatie opnieuw naar PE-online sturen? De poging wordt opnieuw opgebouwd uit de huidige registratienummers van de gebruiker en de accreditatie-instellingen van de cursus.',
        'accrRetry.dialogDisclaimer': 'Let op: of de accreditatie wordt geaccepteerd bepaalt PE-online, SDB kan dat niet garanderen.',
        'accrRetry.sending': 'Bezig met versturen…',
        'accrRetry.sent': 'Opnieuw verstuurd naar PE-online. Nieuwe status: ${this.status}',
        'accrRetry.notSent': 'Niet verstuurd: ${this.reason}',
        'accrRetry.alreadyAccepted': 'Deze accreditatie is al geaccepteerd door PE-online.',
        'accrRetry.noUserRegistration': 'Er zijn geen registratienummers bekend voor deze gebruiker.',
        'accrRetry.noApplicableMapping': 'Er is geen geldige accreditatie-instelling voor deze beroepsorganisatie op de datum van voldaan, of de gebruiker heeft geen registratienummer van het vereiste type.',
        'accrRetry.failed': 'Het opnieuw versturen van de accreditatie is niet gelukt.',
        'allStatuses': 'Alle statussen',
        'allOrganizations': 'Alle beroepsorganisaties',
        'filters': 'Filters',
        'resetFilters': 'Filters wissen',
        'sortAccreditations.ProcessedNewest': 'Verwerkt, nieuwste eerst',
        'sortAccreditations.ProcessedOldest': 'Verwerkt, oudste eerst',
        'sortAccreditations.User': 'Gebruiker',
        'sortAccreditations.Status': 'Status',
        'accr.endDate': 'Voldaan',

        'preset_default': 'Rondt af bij een resultaat van 100',
        'preset_immediately': 'Rondt direct af',
        'preset_firstResult': 'Rondt af bij het eerste resultaat',
        'preset_score': 'Rondt af wanneer het resultaat hoger of gelijk is aan',
        'preset_noScore': 'Geen score',
        'preset_showScore': 'Score',
        'preset_masteryScore': 'Score en voldaan/niet voldaan op basis van cesuur',
        'supplier': 'Leverancier',
        'playerType': 'Type',
        'all': 'Alle',

        'pe.externalPersonId': 'PE-online Persoons ID',
        'pe.courseId': 'PE-online Cursus ID',
        'pe.courseName': 'PE-online Cursusnaam',
        'pe.editionId': 'PE-online Editie ID',
        'pe.moduleId': 'PE-online Module ID',
        'pe.organization': 'Beroepsorganisatie',
        'pe.duration': 'Looptijd',
        'pe.duration.start': 'Looptijd start datum',
        'pe.duration.end': 'Looptijd eind datum',
        'pe.institution': 'Instelling',
        'pe.points': 'Punten',

        'copyOptions': 'Kopieer de volgende eigenschappen van dit catalogus item:',
        'flags.title': 'Naam',
        'flags.description': 'Omschrijving',
        'flags.summary': 'Samenvatting',
        'flags.image': 'Afbeelding',
        'flags.categories': 'Categorieen',
        'flags.documents': 'Documenten',
        'flags.evaluation': 'Evaluatie formulier',
        'flags.certificate': 'Certficaat',

        'errChooseBetween0_10': 'Kies een aantal tussen 0 en 10',
        'errChooseBetween0_100': 'Kies een score tussen 0 en 100',
        'errRequired': 'Dit veld is verplicht',
        'errorOccurred': 'Er is een fout opgetreden',

        'launchtype_regular': 'In het huidge scherm (standaard)',
        'launchtype_newwindow': 'In een nieuw scherm/tabblad',
        'launchtype_newchromelesswindow': 'In een nieuw venster zonder browserknoppen',

        'createScormItemHelper': 'Naam wordt automatisch gevuld bij een geldige upload.',

        'youtube_url': 'YouTube link',
        'youtube_videoId': 'YouTube video ID',
        'youtube_autoplay': 'Automatisch afspelen',
        'youtube_mute': 'Stil afspelen',
        'youtube_startAt': 'Start op (uu:mm:ss)',
        'youtube_endAt': 'Stop op (uu:mm:ss)',
        'youtubeUrlParseHelper': 'Plak hier een YouTube “Delen”-link en klik op de knop om de videogegevens op te halen.',

        'headerVimeoItems': 'Vimeo video\'s',
        'vimeoItemPublished': 'Vimeo video gepubliceerd',
        'vimeoItemUnpublished': 'Publicatie Vimeo video teruggedraaid',
        'vimeoItemCreated': 'Vimeo video aangemaakt',
        'vimeoItemDeleted': 'Vimeo video verwijderd',
        'vimeoItemSaved': 'Vimeo video opgeslagen',

        'publishHeadingVimeoItem': 'Vimeo video publiceren?',
        'publishBodyVimeoItem': 'Deze Vimeo video wordt gepubliceerd naar de Catalogus.',
        'unpublishHeadingVimeoItem': 'Terugdraaien publicatie Vimeo video?',
        'unpublishBodyVimeoItem': 'Deze Vimeo video wordt verwijderd uit de Catalogus.',

        'createHeadingVimeoItem': 'Nieuwe Vimeo video aanmaken?',
        'createHeadingVimeoItemHelper': 'Gebruik de Delen-knop in Vimeo om de link van de video te kopiëren.',

        'noVimeoItemsFound': 'Er zijn geen Vimeo video\'s gevonden',
        'no_captions': 'Geen ondertiteling',

        'vimeo_url': 'Vimeo link',
        'vimeo_videoId': 'Vimeo video ID',
        'vimeo_autoplay': 'Automatisch afspelen',
        'vimeo_mute': 'Stil afspelen',
        'vimeo_startAt': 'Start op (uu:mm:ss)',
        'vimeo_endAt': 'Stop op (uu:mm:ss)',
        'vimeo_captions': 'Ondertiteling',
        'vimeo_hash': 'Privé-toegangscode',
        'vimeoUrlParseHelper': 'Plak hier een Vimeo “Delen”-link en klik op de knop om de videogegevens op te halen.',
        'vimeoHashHelper': 'Deze video is privé. De automatisch gedetecteerde toegangscode kan niet worden aangepast.',
        'vimeoEndAtHelper': 'De eindtijd van Vimeo wordt momenteel niet volledig ondersteund. Het kan in sommige browsers werken, maar is niet gegarandeerd.',

        'language_nl': 'Nederlands',
        'language_en': 'Engels',

        'parseUrl': 'Video-informatie ophalen',
    },
};
